import { FormattedMessage } from 'react-intl';
import React from 'react';
import {
  Box,
  CircularProgress,
  DialogContent,
  Typography,
} from '@mui/material';

export default function PendingAcceptanceDialogBody({ loading, children }) {
  if (loading) {
    return (
      <DialogContent>
        <Box textAlign="center">
          <CircularProgress size="30px" />
          <Typography>
            <FormattedMessage id="PROCESSING" defaultMessage="Processing" />
          </Typography>
        </Box>
      </DialogContent>
    );
  }

  return children;
}
